import { render, staticRenderFns } from "./MagnifyIcon.vue?vue&type=template&id=56e49b1c&scoped=true&"
import script from "./MagnifyIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MagnifyIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e49b1c",
  null
  
)

export default component.exports